import React from 'react';

import { MobilizationStatistics } from './MobilizationStatistics';
import {
    getAppConfig,
    getMobilizationStatistics,
    getTodayMobilizationStatistics,
    getMobilizationStatisticsSyncDate,
    loadVendorsNickNames,
    loadBranchCodes,
} from '../../apiClient';
import { useOptionsForSelectFields } from './helpers';

export function MobilizationStatisticsPage() {
    const options = useOptionsForSelectFields({
        loadVendors: loadVendorsNickNames,
        loadAppConfig: getAppConfig,
        loadBranchCodes: loadBranchCodes,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fetchRange = getMobilizationStatistics as any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fetchSyncDate = getMobilizationStatisticsSyncDate as any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fetchToday = getTodayMobilizationStatistics as any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionsProps = options as any;
    return (
        <MobilizationStatistics
            fetchRange={fetchRange}
            fetchSyncDate={fetchSyncDate}
            fetchToday={fetchToday}
            {...optionsProps}
        />
    );
}
